import { useCallback, useEffect, useState } from 'react';

import { TextArea } from '@/lib/base/forms/textarea/textarea';
import { ConfirmationDialog } from '@/lib/base/overlays';

const AGENT_GUIDANCE_MAX_LENGTH = 10000;

export interface EditMemberGuidanceModalProps {
  isOpen: boolean;
  memberName: string;
  currentGuidance: string;
  isSaving: boolean;
  errorMessage: string | null;
  onSave: (guidance: string) => void;
  onCancel: () => void;
}

export function EditMemberGuidanceModal({
  isOpen,
  memberName,
  currentGuidance,
  isSaving,
  errorMessage,
  onSave,
  onCancel,
}: EditMemberGuidanceModalProps) {
  const [value, setValue] = useState(currentGuidance);

  useEffect(() => {
    if (isOpen) {
      setValue(currentGuidance);
    }
  }, [currentGuidance, isOpen]);

  const handleConfirm = useCallback(() => {
    onSave(value);
  }, [onSave, value]);

  const handleChange = useCallback((newValue: string) => {
    setValue(newValue);
  }, []);

  return (
    <ConfirmationDialog
      isOpen={isOpen}
      title={`Edit agent guidance for ${memberName}`}
      variant='default'
      confirmLabel='Save'
      cancelLabel='Cancel'
      isLoading={isSaving}
      onConfirm={handleConfirm}
      onCancel={onCancel}
      instance='edit-member-guidance'
    >
      <TextArea
        label='Agent guidance'
        value={value}
        onChange={handleChange}
        maxLength={AGENT_GUIDANCE_MAX_LENGTH}
        isDisabled={isSaving}
        rows={6}
      />
      {errorMessage && (
        <p className='mt-2 text-body-small text-[var(--color-text-error-primary)]'>
          {errorMessage}
        </p>
      )}
    </ConfirmationDialog>
  );
}
